import { BoolMustNot, FacetAccessor, RefinementListFilter } from 'searchkit'

export default class ExcludeCheckboxFilter extends RefinementListFilter {
    defineAccessor() {
        const excludeAccessor = new FacetAccessor(
            this.props.field,
            this.getAccessorOptions(),
        )

        excludeAccessor.getBoolBuilder = () => {
            return BoolMustNot
        }
        return excludeAccessor
    }
}
